import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import TermsAndConditions from "./privacyPolicy/TermsAndConditions";
import LoginPopup from "../components/LoginPopup/LoginPopup";
import ChildApp from "../ChildApp";
import ResponsibleGaming from "./privacyPolicy/ResponsibleGaming";
import OfflinePopup from "../OfflinePopup";
import SocketProvider from "../SocketProvider";

export default function AppRouter({ checkScript }) {
  const location = useLocation();
  const [privacy, setPrivacy] = useState(false);

  useEffect(() => {
    setPrivacy(
      location.pathname === "/terms-and-conditions" ||
        location.pathname === "/responsible-gaming"
    );
  }, [location]);

  return (
    <SocketProvider>
      <>
        {privacy ? (
          location.pathname === "/terms-and-conditions" ? (
            <TermsAndConditions />
          ) : location.pathname === "/responsible-gaming" ? (
            <ResponsibleGaming />
          ) : (
            <></>
          )
        ) : (
          <>
            <LoginPopup />
            <ChildApp />
            {checkScript()}
          </>
        )}
        <OfflinePopup />
      </>
    </SocketProvider>
  );
}
